<form [formGroup]="sectionsContainer.formGroup">

  <app-section-view-edit
    [isLocationOperation]="isLocationOperation"
    [sectionsContainer]="sectionsContainer"
    [sectionsToShow]="sectionsToShow"
    (closeEdit)="onCloseEdit()"
  ></app-section-view-edit>

</form>
